/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable prefer-template */
/* eslint-disable object-shorthand */
import React, { SetStateAction, useEffect, useState } from "react";
import {Bar, Doughnut, Pie} from 'react-chartjs-2'
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { BarChartRounded, ChatRounded, DonutLargeSharp, DonutSmall, DonutSmallOutlined, DonutSmallSharp, PieChartRounded } from "@material-ui/icons";
import { ReportSummary } from "./report.worker";

interface ChartObj {
    title: string;
    data: number[] | Array<number[]> | number[][][] | any;
    labels: string[] | string[][];
    type: string;
    id: string | number,
    visible: boolean
}

export const chartBgs = [
    "#33a02ccc",
    "#1f78b4cc",
    "#a6cee3cc",
    "#e31a1ccc",
    "#ff7f00cc",
    "#6a3d9acc",
    "#b2df8acc",
    "#fb9a99cc",
    "#fdbf6fcc",
    "#cab2d6cc",
]
const platformBgs = [
    "#FF7A00cc",
    "#3391c6cc"
]
const platformTransferBgs = [
    "#FF7A00cc",
    "#ff5a00cc",
    "#61b3decc",
    "#1f78b4cc"
]
const sentimentBgs = [
  "#33a02ccc",
  "#1f78b4cc",
  "#a6cee3cc",
  "#fdbf6fcc",
  "#e31a1ccc",
]

const bgGetter = (title: string): string[] => {
    if (title === 'Call Results') return chartBgs;
    if (title === 'Platform Activity') return platformBgs;
    if (title === 'Platform Transfers' || title === "Direct Calls") return platformTransferBgs;
    if (title === "Sentiment Score") return sentimentBgs
    return chartBgs;
}

const renderPercentageTooltip = (context: any) => {
    const value = context.raw as number || 0;
    const total = context.dataset.data.reduce((acc: number, curr: number) => acc + curr, 0);
    return `${context.label}: ${Math.round(value / total * 100)}%`;
}



const defaultConfigsCX = [
  {
    title: "Call Type",
    id: 1,
    data: [
      0,
      0,
      0,
    ],
    labels: ["Inbound", "Outbound", "Internal"],
    type: "donut",
    visible: true,
  },
  // platform transfers
  {
    title: "Platform Transfers",
    id: 2,
    data: [
      0,
      0,
    ],
    labels: [
      ["CX In", "CX Out"],
      ["EX In", "EX Out"],
    ],
    type: "donut",
    visible: true
  },
  // platform activity
  {
      title: "Platform Activity",
      id: 3,
      data: [
         0, 0
      ],
      labels: ["CX", "EX"],
      type: "donut",
      visible: true,
  },
  {
    title: "Direct Calls",
    id: 7,
    data: [
      [0,0],
      [0,0]
    ],
    labels: [
      ["CX In", "CX Out"],
      ["EX In", 'EX Out'],
    ],
    type: 'bar',
    visible: true
  },
    // call results
  {
    title: "Call Results",
    id: 4,
    data: [
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
    ],
    labels: ['Complete', "Abandoned", "Missed", "Transferred", "Abandoned VM", "Left VM", "Fax Received", "Queue Abn.", "Queue Left VM", "Queue Abn. VM"],
    type: "donut",
    visible: true,
  },
  // call recordings
  {
    title: "Call Recordings",
    id: 5,
    data: [
      0,
      0,
    ],
    labels: ['Recordings', "Transcripts"],
    type: "donut",
    visible: true,
  },
  // sentiment score
  {
    title: "Sentiment Score",
    id: 6,
    data: [
      0,
      0,
      0,
      0,
      0,
    ],
    labels: ['Very Positive', "Positive", "Neutral", "Negative", "Very Negative"],
    type: "donut",
    visible: true,
  },
]

const Widget = ({d, mode, setChartData}: {d: ChartObj, mode: string, setChartData: React.Dispatch<SetStateAction<ChartObj[]>>}) => {
    const {title, data, labels, type, visible} = d;
    
    return (
        <div className={`report-widget-container ${visible ? 'report-widget-visible' : 'report-widget-hidden'}`} style={{
            background: mode === 'light' ? "linear-gradient(0deg, rgb(247, 247, 247), rgb(255, 255, 255))" : "linear-gradient(10deg, rgb(20, 20, 20), rgb(37, 40, 41))",
            border: mode === 'light' ? "1px solid #cecece" : "1px solid #141414",
            marginRight: mode === 'light' ? 2 : 0,
            position: 'relative',
        }}>
           <div style={{position: 'absolute', right: 5,
             top: 5
           }}>
           <button 
           type="button" 
           style={{cursor: "pointer", margin: 3, background: 0, border: 0}} 
           onClick={() => {
              setChartData((prev: ChartObj[]) => {
                localStorage.setItem('report-headlines-config', JSON.stringify(prev?.map((p) => p.title === title ? ({...p, type: 'donut', data: []}) : ({...p, data: []}))))
                return prev?.map((p) => p.title === title ? ({...p, type: 'donut'}) : ({...p}))})
          }}>
                <DonutLargeSharp style={{color: mode === 'light' ? "black" : "white"}} fontSize="small" />
            </button>
            <button type='button' style={{cursor: "pointer", margin: 3, background: 0, border: 0}}
            onClick={() => setChartData((prev: ChartObj[]) => {
              localStorage.setItem('report-headlines-config', JSON.stringify(prev?.map((p) => p.title === title ? ({...p, type: 'bar', data: []}) : ({...p, data: []}))))
              return prev?.map((p) => p.title === title ? ({...p, type: 'bar'}) : ({...p}))
            })}>
                <BarChartRounded style={{color: mode === 'light' ? "black" : "white"}} fontSize="small" />
            </button>
           </div>
            {/* {title} */}
            {
                data && labels && type === 'donut' && (
                    <Doughnut
                        plugins={[]}
                        options={{
                            layout: {
                                padding: {
                                    top: 10,
                                    left: 10,
                                    right: 0,
                                    bottom: 10,
                                }
                            },
                            responsive: true,
                            aspectRatio: 1.6,
                            plugins: {
                                tooltip: {
                                    callbacks: title === 'Platform Activity' ? {
                                        label: (context) => renderPercentageTooltip(context)
                                    } : {}
                                },
                                title: {
                                    display: true,
                                    align: "start",
                                    color: mode === "light" ? "black" : "white",
                                    padding: {
                                        bottom: 15
                                    },
                                    font: {
                                        size: 17,
                                    },
                                    text: `${title}`,
                                },
                                legend: {
                                display: true,
                                position: "right",
                                align: "end",
                                rtl: true,
                                labels: {
                                    padding: 7,
                                    usePointStyle: true,
                                    pointStyle: "rectRounded",
                                    color: mode === "light" ? "#333" : "#ccc",
                                    font: {
                                        size: 10,
                                        style: "normal",
                                        },
                                    },
                                },
                                
                            },
                        }}
                        data={{
                        labels: labels.flat() || [],
                        datasets: [
                            {
                            data: data.flat(),
                            backgroundColor: bgGetter(title),
                            borderColor: bgGetter(title),
                            borderWidth: 1,
                            },
                        ],
                        }}
                    />
                )
            }
            {
                data && labels && type === 'bar' && (
                    <Bar
                        plugins={[]}
                        options={{
                            scales: {
                                  x: {
                                    stacked: title === 'Platform Transfers',
                                    
                                  },
                                  y: {
                                    stacked: title === 'Platform Transfers',
                                    // title: {
                                    //   display: true,
                                    //   text: 'Value'
                                    // },
                                    min: 0,
                                    ticks: title==='Platform Activity' ? {
                                        stepSize: 100,
                                        autoSkip: false,
                                        color: mode === 'light' ? 'black' : 'white'
                                      } : {
                                        autoSkip: false,
                                        color: mode === 'light' ? 'black' : 'white'
                                      }
                                  }
                            },
                            indexAxis: title === 'Call Results' ? 'y' : "x",
                            layout: {
                                padding: {
                                    top: 10,
                                    left: 10,
                                    right: 0,
                                    bottom: 10,
                                }
                            },
                            responsive: true,
                            aspectRatio: 1.6,
                            plugins: {
                                tooltip: {
                                    callbacks: title === 'Platform Activity' ? {
                                        label: (context) => renderPercentageTooltip(context)
                                    } : {}
                                },
                                title: {
                                    display: true,
                                    align: "start",
                                    color: mode === "light" ? "black" : "white",
                                    padding: {
                                        bottom: 15
                                    },
                                    font: {
                                        size: 17,
                                    },
                                    text: `${title}`,
                                },
                                legend: {
                                display: false,
                                position: "right",
                                align: "end",
                                rtl: true,
                                labels: {   
                                    padding: 7,
                                    usePointStyle: true,
                                    pointStyle: "rectRounded",
                                    color: mode === "light" ? "#333" : "#aaa",
                                    font: {
                                        size: 10,
                                        style: "normal",
                                        },
                                    },
                                },
                                
                            },
                        }}
                        data={{
                        labels: title === "Platform Transfers" ? ["In", "Out"] : labels.flat() || [] ,
                        datasets: title === "Platform Transfers" || title === 'Direct Calls' ? [
                          {
                          data: data[0],
                          backgroundColor: bgGetter(title).slice(0, 2),
                          borderColor: bgGetter(title).slice(0, 1),
                          borderWidth: 1,
                          },
                          {
                            data: data[1],
                            backgroundColor: bgGetter(title).slice(-2),
                            borderColor: bgGetter(title).slice(-2),
                            borderWidth: 1,
                            },
                        ] : [
                          {
                          data: data.flat(),
                          backgroundColor: bgGetter(title),
                          borderColor: bgGetter(title),
                          borderWidth: 1,
                          },
                        ],
                        }}
                    />
                )
            }
        </div>
    )
}


function HeadlinesReport({ data , mode, hasCX }: { data: ReportSummary[] , mode: string, hasCX: boolean,}) {
  const [chartData, setChartData] = useState<ChartObj[]>([]);
  const [sidebar, setSidebar] = useState(false)
  const handleDragEnd = (result: any) => {
    if (!result.destination) return;
    if (chartData) {
        const newBox = Array.from(chartData)
        const [draggeditem] = newBox.splice(result.source.index, 1);
        newBox.splice(result.destination.index, 0, draggeditem)
        // console.log('new: ', newBox.map((c) => ({...c, data: []})))
        localStorage.setItem('report-headlines-config', JSON.stringify(newBox.map((c) => ({...c, data: []}))))
        setChartData(newBox)
    }
};

  useEffect(() => {
    const reportHeadlinesConfigInStorage = localStorage.getItem('report-headlines-config')
    if (!reportHeadlinesConfigInStorage) {
      setChartData(defaultConfigsCX)
      localStorage.setItem('report-headlines-config', JSON.stringify(defaultConfigsCX))
    }
    else {
      setChartData(JSON.parse(reportHeadlinesConfigInStorage))
    }
  }, [])

  useEffect(() => {
    if (!chartData.length) return;
    if (data.length) {
      console.log(data[2])
      const cxData = data?.find((d) => d.platform === "CX")
      const exData = data?.find((d) => d.platform === 'EX')
      const totalsData = data?.find((d) => d.platform === 'Total')
      
      const getLocalChartConfigs = localStorage.getItem('report-headlines-config')

      if (getLocalChartConfigs) {
        const parsedChartsFromStorage = JSON.parse(getLocalChartConfigs)
        const chartsWithPopulatedData = parsedChartsFromStorage.map((chart: ChartObj) => ({
          ...chart, 
          data: 
          (() => {
            if (chart.title === "Call Results") {
              return [
                (totalsData?.complete || 0),
                (totalsData?.abandoned || 0),
                (totalsData?.missed || 0), 
                (totalsData?.transferred || 0),
                (totalsData?.abandonedVoicemail || 0),
                (totalsData?.leftVoicemail || 0),
                (totalsData?.faxReceived || 0),
                (totalsData?.queueAbandoned || 0),
                (totalsData?.queueLeftVoicemail || 0),
                (totalsData?.queueAbandonedVoicemail || 0)
            ]
            }
            if (chart.title === 'Call Type') {
              return [
                (cxData?.callsInbound || 0) + (exData?.callsInbound || 0) + (totalsData?.callsInbound || 0),
              (cxData?.callsOutbound || 0) + (exData?.callsOutbound || 0) + (totalsData?.callsOutbound || 0),
              (cxData?.callsInternal || 0) + (exData?.callsInternal || 0) + (totalsData?.callsInternal || 0),
              ]
            }
            if (chart.title === 'Platform Transfers') {
              return [
                [(cxData?.callsIn || 0), (cxData?.callsOut || 0)],
                [(exData?.callsIn || 0), (exData?.callsOut || 0)],
              ]
            }
            if (chart.title === 'Direct Calls') {
              return [
                [(cxData?.directCallsIn || 0), (cxData?.directCallsOut || 0)],
                [(exData?.directCallsIn || 0), (exData?.directCallsOut || 0)]
              ]
            }
            if (chart.title === "Platform Activity") {
              return [
                Math.round(
                    (100 * ((cxData?.durationInbound || 0) + (cxData?.durationOutbound || 0) + (cxData?.durationInternal || 0))) / 
                    (((cxData?.durationInbound || 0) + (cxData?.durationOutbound || 0) + (cxData?.durationInternal || 0)) + 
                    ((exData?.durationInbound || 0) + (exData?.durationOutbound || 0) + (exData?.durationInternal || 0)))),
                Math.round(
                    (100 * ((exData?.durationInbound || 0) + (exData?.durationOutbound || 0) + (exData?.durationInternal || 0))) / 
                    (((exData?.durationInbound || 0) + (exData?.durationOutbound || 0) + (exData?.durationInternal || 0)) + 
                    ((cxData?.durationInbound || 0) + (cxData?.durationOutbound || 0) + (cxData?.durationInternal || 0)))),
              ]
            }
            if (chart.title === 'Call Recordings') {
              return [
                (totalsData?.recordings),
                (totalsData?.transcripts),
              ]
            }
            if (chart.title === 'Sentiment Score') {
              return [
                (totalsData?.sentimentScore.veryPositive || 0),
                (totalsData?.sentimentScore.positive || 0),
                (totalsData?.sentimentScore.neutral || 0),
                (totalsData?.sentimentScore.negative || 0),
                (totalsData?.sentimentScore.veryNegative || 0)
              ]
            }
            return []
          })()
          
        }))
       setChartData(chartsWithPopulatedData)
      }

      if (!getLocalChartConfigs) {
        const configs = defaultConfigsCX.map((chart) => ({
          ...chart,
          data: 
          (() => {
            if (chart.title === "Call Results") {
              return [
                (totalsData?.complete || 0),
                (totalsData?.abandoned || 0),
                (totalsData?.missed || 0), 
                (totalsData?.transferred || 0),
                (totalsData?.abandonedVoicemail || 0),
                (totalsData?.leftVoicemail || 0),
                (totalsData?.faxReceived || 0),
                (totalsData?.queueAbandoned || 0),
                (totalsData?.queueLeftVoicemail || 0),
                (totalsData?.queueAbandonedVoicemail || 0)
            ]
            }
            if (chart.title === 'Call Type') {
              return [
                (cxData?.callsInbound || 0) + (exData?.callsInbound || 0) + (totalsData?.callsInbound || 0),
              (cxData?.callsOutbound || 0) + (exData?.callsOutbound || 0) + (totalsData?.callsOutbound || 0),
              (cxData?.callsInternal || 0) + (exData?.callsInternal || 0) + (totalsData?.callsInternal || 0),
              ]
            }
            if (chart.title === 'Platform Transfers') {
              return [
                [(cxData?.callsIn || 0), (cxData?.callsOut || 0)],
                [(exData?.callsIn || 0), (exData?.callsOut || 0)],
              ]
            }
            if (chart.title === 'Direct Calls') {
              return [
                [(cxData?.directCallsIn || 0), (cxData?.directCallsOut || 0)],
                [(exData?.directCallsIn || 0), (exData?.directCallsOut || 0)]
              ]
            }
            if (chart.title === "Platform Activity") {
              return [
                Math.round(
                    (100 * ((cxData?.durationInbound || 0) + (cxData?.durationOutbound || 0) + (cxData?.durationInternal || 0))) / 
                    (((cxData?.durationInbound || 0) + (cxData?.durationOutbound || 0) + (cxData?.durationInternal || 0)) + 
                    ((exData?.durationInbound || 0) + (exData?.durationOutbound || 0) + (exData?.durationInternal || 0)))),
                Math.round(
                    (100 * ((exData?.durationInbound || 0) + (exData?.durationOutbound || 0) + (exData?.durationInternal || 0))) / 
                    (((exData?.durationInbound || 0) + (exData?.durationOutbound || 0) + (exData?.durationInternal || 0)) + 
                    ((cxData?.durationInbound || 0) + (cxData?.durationOutbound || 0) + (cxData?.durationInternal || 0)))),
              ]
            }
            if (chart.title === 'Call Recordings') {
              return [
                (totalsData?.recordings),
                (totalsData?.transcripts),
              ]
            }
            if (chart.title === 'Sentiment Score') {
              return [
                (totalsData?.sentimentScore.veryPositive || 0),
                (totalsData?.sentimentScore.positive || 0),
                (totalsData?.sentimentScore.neutral || 0),
                (totalsData?.sentimentScore.negative || 0),
                (totalsData?.sentimentScore.veryNegative || 0)
              ]
            }
            return []
          })()
        }))
       
        localStorage.setItem('report-headlines-config', JSON.stringify(configs.map((c) => ({...c, data: [c.labels.map(() => 0)]}))))
        setChartData(configs)
      }
    }
    // setChartData(chartArr)
  }, [data]);
  

  return (
    <>
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="report-widget-boxes" direction="horizontal">
        {(provided) => 
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="report-headlines-container-parent"
            style={{
              background: mode === 'light' ? "white" : "#181818",
              border: "1px solid #68686e",
              borderBottom: 0,
              display: "flex",
              marginRight: sidebar ? 281 : 30
            }}
          >
            {chartData && chartData.length && 
              chartData.map((chart, i, arr) => 
                <Draggable draggableId={chart.title} index={i} key={chart.title}>
                  {(providedInner) => (
                    <div className={`ccrt-draggable ${chart.visible ? "visible" : 'hidden'}`}
                      ref={providedInner.innerRef}
                      {...providedInner.dragHandleProps}
                      {...providedInner.draggableProps}
                    >
                      <Widget mode={mode} d={chart} setChartData={setChartData} />
                    </div>
                  )}
                </Draggable>
              )}
             {provided.placeholder}
          </div>
        }
      </Droppable>
    </DragDropContext>
    <div 
    style={{
      width: 30, 
      height: 253,
      position: 'absolute', 
      right: 0, 
      top: 50,
      background: mode === 'light' ? "#fff" : "#181d1f", 
      border: mode === 'light' ? "1px solid #babfc7" : "1px solid #68686e",
      borderLeft:  mode === 'light' ? "1px solid #babfc7" : "1px solid #68686e"
    }}>
     {
      sidebar && (
        <div style={{
          left: -252,
          background: mode === 'light' ? "rgb(246,246,246)" : '#222628',
          top: -1,
          width: 250,
          height: 253,
          position: 'absolute',
          border:  mode === 'light' ? "1px solid #babfc7" : "1px solid #68686e"
        }}>
           {
            chartData && chartData.length && chartData.map((chart) => (
              <div style={{margin: 10, display: 'flex', alignItems: 'center', justifyContent: 'start'}}>
                <div className={`${chart.visible ? "ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper ag-checked" : "ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper" }`}>
                <input style={{backgroundColor: '#2196f3'}} type="checkbox" checked={chart.visible} onChange={() => {
                  localStorage.setItem(
                    'report-headlines-config',
                    JSON.stringify(chartData.map((c) =>c.title === chart.title ? { ...c, visible: !c.visible, data: [] } : { ...c, data: [] })
                    )
                  );              
                  return setChartData((prev) => prev.map((c) =>c.title === chart.title ? { ...c, visible: !c.visible } : { ...c }))
                  }}/>
                  </div>
                <span style={{paddingLeft: 10}}>{chart.title}</span>
              </div>
            ))
           }
        </div>
      )
     }
       
       <button 
       type="button"
       onClick={() => setSidebar((p) => !p)}
       style={{
        position: 'absolute', 
        left: -18, 
        top: 90,
        color: mode === 'light' ? "black" : 'white',
        background: '#00000000',
        border: 0,
        display: 'flex', 
        transform: 'rotate(90deg)',
        alignItems: 'center',
        cursor: 'pointer'
        }}
        >
          <DonutSmallSharp style={{fontSize: '1.2em', color: mode === 'light' ? 'black' : 'white'}} /><span>Charts</span>
        </button>
      </div>
  </>
  );
}

export default HeadlinesReport;
